// LIST
export const FETCH_PACKAGES = "app/Package/FETCH_PACKAGES";
export const FETCH_PACKAGES_SUCCESS = "app/Package/FETCH_PACKAGES_SUCCESS";
export const FETCH_PACKAGES_FAILURE = "app/Package/FETCH_PACKAGES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Package/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Package/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Package/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_PACKAGE = "app/Package/ADD_PACKAGE";
export const ADD_PACKAGE_SUCCESS = "app/Package/ADD_PACKAGE_SUCCESS";
export const ADD_PACKAGE_FAILURE = "app/Package/ADD_PACKAGE_FAILURE";

// EDIT
export const EDIT_PACKAGE = "app/Package/EDIT_PACKAGE";
export const EDIT_PACKAGE_SUCCESS = "app/Package/EDIT_PACKAGE_SUCCESS";
export const EDIT_PACKAGE_FAILURE = "app/Package/EDIT_PACKAGE_FAILURE";

// DELETE
export const DELETE_PACKAGE = "app/Package/DELETE_PACKAGE";
export const DELETE_PACKAGE_SUCCESS = "app/Package/DELETE_PACKAGE_SUCCESS";
export const DELETE_PACKAGE_FAILURE = "app/Package/DELETE_PACKAGE_FAILURE";
